export default function() {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    // { label: "openid", prop: "openid", slots: "openid" },
    { label: "店铺名称", prop: "store_name", width: 130 },
    { label: "联系人", prop: "boss_name", width: 100 },
    { label: "手机号", prop: "store_phone" },
    { label: "地址", prop: "store_addr" },
    // { label: "店长微信是否绑定", prop: "openid", slots: "openid" },
    // { label: "等级", prop: "grade", slots: "grade" },
    // { label: "到期时间", prop: "vip_date" },
    {
      label: "营业时间",
      prop: "workTime",
      slots: "workTime",
      width: 130
    },
    {
      label: "门店照片",
      prop: "storeImg",
      slots: "storeImg",
      width: 130
    },
    {
      label: "创建时间",
      prop: "create_time",
      width: 180,
      // slots: "state",
    },
    {
      label: "操作",
      prop: "operation",
      width: 150,
      slots: "operation",
      // fixed: "right",
    },
  ];
}
